import { forwardRef, type Ref, type SVGProps } from "react";
const IconHammerOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M15.48 25a1 1 0 0 0 1 1 1 1 0 1 0-1-1" />
    <path d="M28.38 6a5 5 0 0 0-4-2h-.58A3 3 0 0 0 21 2h-9a3 3 0 0 0-3 3h-.06a2.52 2.52 0 0 0-2.46-2h-1A2.51 2.51 0 0 0 3 5.51v5A2.52 2.52 0 0 0 5.52 13h1a2.52 2.52 0 0 0 2.46-2H9a3 3 0 0 0 3 3h.88L12 25.35v.16a4.4 4.4 0 0 0 2.54 4.07A4.53 4.53 0 0 0 21 25.5v-.15L20.12 14H21a3 3 0 0 0 3-3v-1h.67l.8.26a2.5 2.5 0 0 0 .85.14A2.69 2.69 0 0 0 29 8.16 2.8 2.8 0 0 0 28.38 6M19 25.5a2.5 2.5 0 1 1-5 0l.87-11.5h3.22zm7.3-17.1h-.23l-.79-.27a2 2 0 0 0-.63-.1H23a1 1 0 0 0-1 1v2a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V10a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v.48a.52.52 0 0 1-.52.52h-1a.52.52 0 0 1-.48-.52v-5A.52.52 0 0 1 5.52 5h1a.52.52 0 0 1 .48.52V6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1 1 1 0 0 0 1 1h1.39a3 3 0 0 1 2.49 1.34.68.68 0 0 1-.58 1.06" />
  </svg>
);
const ForwardRef = forwardRef(IconHammerOutlineSVG);
ForwardRef.displayName = "IconHammerOutline";
export { ForwardRef as IconHammerOutline };
